/**
 * Returns `true` when the line item has no participant because it came from a
 * non-group order, or when it belongs to the current customer in a group order.
 */
export function checkIfCanBeReorderedByCustomer(lineItem: LineItem) {
  return !lineItem.orderParticipant || lineItem.orderParticipant.isMe;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type LineItem = {
  readonly orderParticipant?: { readonly isMe: boolean } | null;
};
